import axios from "./axios";

export default {
  getLayouts() {
    return axios({
      method: "GET",
      url: "/branch-dte-template-settings/layouts",
      headers: { "content-type": "application/json" },
    }).then((response) => response.data);
  },

  getSettings(branchId, layoutKey) {
    return axios({
      method: "GET",
      url: `/branch-dte-template-settings/${branchId}/${layoutKey}`,
      headers: { "content-type": "application/json" },
    }).then((response) => response.data);
  },

  saveSettings(branchId, layoutKey, settings) {
    return axios({
      method: "PUT",
      url: `/branch-dte-template-settings/${branchId}/${layoutKey}`,
      headers: { "content-type": "application/json" },
      data: { settings },
    }).then((response) => response.data);
  },

  setDefaultLayout(branchId, layoutKey, settings) {
    return axios({
      method: "POST",
      url: `/branch-dte-template-settings/${branchId}/${layoutKey}/default`,
      headers: { "content-type": "application/json" },
      data: { settings },
    }).then((response) => response.data);
  },

  copyLayoutToAllBranches(branchId, layoutKey, settings) {
    return axios({
      method: "POST",
      url: `/branch-dte-template-settings/${branchId}/${layoutKey}/copy-to-all`,
      headers: { "content-type": "application/json" },
      data: { settings },
    }).then((response) => response.data);
  },

  resetSettings(branchId, layoutKey) {
    return axios({
      method: "POST",
      url: `/branch-dte-template-settings/${branchId}/${layoutKey}/reset`,
      headers: { "content-type": "application/json" },
    }).then((response) => response.data);
  },
};
